import styled from "@emotion/styled";
import type { ComponentPropsWithoutRef } from "react";

import { MDSIcon, MDSIconKind } from "@/mds";

export const AgentRowActionButton = ({
  iconKind,
  iconSize = 15,
  size = 28,
  ...buttonProps
}: {
  iconKind: MDSIconKind;
  iconSize?: number;
  size?: number;
} & Omit<ComponentPropsWithoutRef<"button">, "children">) => (
  <StyledButton type="button" $size={size} {...buttonProps}>
    <MDSIcon kind={iconKind} size={iconSize} />
  </StyledButton>
);

const StyledButton = styled.button<{ $size: number }>`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  display: inline-flex;
  height: ${({ $size }) => `${$size}px`};
  justify-content: center;
  padding: 0;
  width: ${({ $size }) => `${$size}px`};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
